// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1w8Az","insightsList":"newBusinessInsightsMenu_insightsList__2hoWx","active":"newBusinessInsightsMenu_active__2Wzlu"};